import React from 'react';
import { Image, Layers } from 'lucide-react';
import { LpGenerationMode } from '../../services/api/lpGenerationService';

interface GenerationModeSelectorProps {
  value: LpGenerationMode;
  onChange: (mode: LpGenerationMode) => void;
}

const OPTIONS: Array<{
  value: LpGenerationMode;
  label: string;
  description: string;
  Icon: React.ComponentType<{ className?: string }>;
}> = [
  {
    value: 'decorative',
    label: '装飾画像モード',
    description: '既存のPC/モバイル両対応LP。本文はHTMLで編集します。',
    Icon: Image,
  },
  {
    value: 'image2_overlay',
    label: 'Image2.0オーバーレイモード',
    description: 'スマホ縦長画像に透明CTAを重ねるビジュアル重視LP。',
    Icon: Layers,
  },
];

const GenerationModeSelector: React.FC<GenerationModeSelectorProps> = ({ value, onChange }) => (
  <fieldset className="grid gap-3 sm:grid-cols-2">
    <legend className="block text-sm font-medium text-gray-700 mb-2">生成モード</legend>
    {OPTIONS.map(({ value: optionValue, label, description, Icon }) => {
      const selected = value === optionValue;
      return (
        <label
          key={optionValue}
          className={`flex items-start gap-3 rounded-lg border p-4 cursor-pointer transition-colors ${
            selected ? 'border-indigo-400 bg-indigo-50' : 'border-warm-border hover:bg-gray-50'
          }`}
        >
          <input
            type="radio"
            name="generation-mode"
            value={optionValue}
            checked={selected}
            onChange={() => onChange(optionValue)}
            className="mt-1"
          />
          <Icon className={`w-5 h-5 mt-0.5 ${selected ? 'text-indigo-600' : 'text-gray-500'}`} />
          <span className="min-w-0">
            <span className="block text-sm font-semibold text-gray-900">{label}</span>
            <span className="block text-xs leading-5 text-gray-600">{description}</span>
          </span>
        </label>
      );
    })}
  </fieldset>
);

export default GenerationModeSelector;
